import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Route guard — renders its children only for the global 'administrator' role,
 * otherwise redirects home. Reserved for what genuinely belongs to that role:
 * anything a non-administrator may legitimately reach should be gated on a
 * permission instead, with RequirePermission. AuthGuard has resolved the user
 * by the time routes render, so `isAdmin` is reliable here.
 */
export default function RequireAdmin({ children }) {
    const { isAdmin } = useAuth();
    if (!isAdmin) return <Navigate to="/" replace />;
    return children;
}
